import { api } from './api';

export interface Location {
  id: string;
  name: string;
  address: string;
  phone?: string;
  isActive: boolean;
  excelFile?: string;
  migratedAt?: string;
  createdAt: string;
  updatedAt: string;
  users?: Array<{
    id: string;
    name: string;
    email: string;
    role: string;
  }>;
  _count?: {
    users: number;
    inventories: number;
    sales: number;
  };
}

export interface LocationsResponse {
  success: boolean;
  data: Location[];
}

export interface LocationResponse {
  success: boolean;
  data: Location;
  message?: string;
}

export interface CreateLocationData {
  name: string;
  address: string;
  phone?: string;
}

export interface UpdateLocationData {
  name?: string;
  address?: string;
  phone?: string;
  isActive?: boolean;
}

export const locationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query<LocationsResponse, { active?: boolean }>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        if (params.active !== undefined) searchParams.append('active', params.active.toString());
        return {
          url: `/locations?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Location'],
    }),

    getLocationById: builder.query<LocationResponse, string>({
      query: (id) => ({
        url: `/locations/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Location', id }],
    }),

    createLocation: builder.mutation<LocationResponse, CreateLocationData>({
      query: (data) => ({
        url: '/locations',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Location'],
    }),

    updateLocation: builder.mutation<LocationResponse, { id: string; data: UpdateLocationData }>({
      query: ({ id, data }) => ({
        url: `/locations/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Location', id }, 'Location'],
    }),

    deleteLocation: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/locations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Location'],
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useGetLocationByIdQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useDeleteLocationMutation,
} = locationsApi;